export default "__VITE_ASSET__CEY6cXR7__"